<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema } from '@bagelink/vue'
const defaults = {
	title: 'Partner with Us',
	description: '<p>The Academic Torah Institute (formerly Project TABS) is a registered 501(c)(3). We bring traditional Torah learning into conversation with rigorous academic scholarship, working with individuals, scholars, educators, and institutions who share this mission.</p><p>Through scholarly collaboration, educational initiatives, content creation, and strategic partnerships, we will grow our library, spark meaningful dialogue, and launch projects that bring critical Jewish scholarship to life for a broad audience.</p>',
	subtitle: 'To explore collaboration, contact:',
	contactName: 'Rabbi David Steinberg',
	contactTitle: 'Director and Co-Founder',
	contactEmail: 'director@thetorah.com',
}
const schema = defineSchema({
	title: $.text('Title'),
	description: $.richtext('Description', { basic: true }),
	subtitle: $.text('Contact Subtitle'),
	contactName: $.text('Contact Name'),
	contactTitle: $.text('Contact Title'),
	contactEmail: $.text('Contact Email'),
})
export const Support = defineBlock({ name: 'Support', label: 'Support / Partner', icon: 'handshake', order: 7, schema, defaults })
</script>
<script setup lang="ts">

import { $ } from '@bagelink/vue'
const myData = defineProps<{
	title?: string
	description?: string
	subtitle?: string
	contactName?: string
	contactTitle?: string
	contactEmail?: string
}>()
</script>

<template>
	<div id="partner" class="txt-center w660px mx-auto pb-8 pt-5 m_pb-2 m_px-1">
		<div class="flex gap-1">
			<div class="line" />
			<h3 class="m-0 txt40 regular m_txt30 line-height-12 white-space ">
				{{ myData.title }}
			</h3>
			<div class="line" />
		</div>
		<div class=" p-2 m_px-0 txt-start paddingP" v-html="myData.description" />
		<p v-if="myData.subtitle" class="balance m_line-height-14 m_pb-1">
			{{ myData.subtitle }}
		</p>
		<p v-if="myData.contactName" class=" balance">
			<strong>{{ myData.contactName }},</strong> {{ myData.contactTitle }}
		</p>
		<a v-if="myData.contactEmail" class="underline" :href="`mailto:${myData.contactEmail}`">{{ myData.contactEmail }}</a>
		<div class="line mt-2" />
	</div>
</template>
